import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../../records";
import { routeConfig } from "./routes";
import { machineDetailConfigurationsComponentConfig } from "./views/machines/detail/configurations";
import {
  vsComponentName as MachineDetailConfigurationsDecommissionComponentName,
  MachineDetailConfigurationsDecommissionComponentOptions,
} from "./views/machines/detail/configurations/decommission";
import {
  vsComponentName as MachineDetailConfigurationsWarehouseComponentName,
  MachineDetailConfigurationsWarehouseComponentOptions,
} from "./views/machines/detail/configurations/warehouse";
import {
  vsComponentName as MachineDetailConfigurationsMoveComponentName,
  MachineDetailConfigurationsMoveComponentOptions,
} from "./views/machines/detail/configurations/move";
import {
  vsName as machineDetailPartsComponentName,
  machineDetailPartsComponentOptions,
  machineDetailPartsComponentConfig,
} from "./views/machines/detail/parts";
import {
  vsName as slotTrakServerAdapterName,
  SlotTrakServerAdapter,
} from "./slotTrakServerAdapter";

import {
  vsComponentName as MachinesDecommissionComponentName,
  MachinesDecommissionViewComponentOptions,
} from "./views/machines/decommission";

// import {
//   vsComponentName as MachinesChangeComponentName,
//   MachinesChangeViewComponentOptions,
// } from "./views/machines/detail/changeDetails";

import {
  vsComponentName as MachinesWarehouseComponentName,
  MachinesWarehouseViewComponentOptions,
} from "./views/machines/warehouse";

import {
  vsComponentName as MachinesMoveComponentName,
  MachinesMoveViewComponentOptions,
} from "./views/machines/move";
import {
  vsComponentName as MachinesSoftwareUpgradeComponentName,
  MachinesSoftwareUpgradeViewComponentOptions,
} from "./views/machinesSoftware/SoftwareUpgrade";

import { vsModuleName as machinesConfigModuleName } from "./config/module";
import { vsModuleName as machinesComponentModuleName } from "./components/module";
import {
  machineDetailProgressiveComponentConfig,
  vsComponentName as machineDetailProgressiveComponentName,
  MachineDetailProgressiveConfigurationComponentOptions,
} from "./views/machines/detail/progressiveConfiguration";
import {
  vsComponentName as machineDetailProgressiveConfigurationEditComponentName,
  MachineDetailProgressiveConfigurationEditComponentOptions,
} from "./views/machines/detail/progressiveConfiguration/edit";
import {
  MachineDetailProgressiveConfigurationGameInfoComponentOptions,
  vsComponentName as MachineDetailProgressiveConfigurationGameInfoComponentName,
} from "./views/machines/detail/progressiveConfiguration/gameConfigurationProgressiveInformation/component";

import {
  CloneAndConversionServiceGateway,
  vsName as CloneAndConversionServiceName,
} from "./services/cloneAndConversionService";
import {
  MachineExportService,
  vsServiceName as machineExportServiceName,
} from "./services/machineExportService";
import { progressiveDefinitionSelectTypeConfig } from "./views/machines/detail/progressiveConfiguration/edit/progressiveDefinitionSelect";

import { vsModuleName as MachineSharedModuleName } from "../shared";
import {
  mainMachinesGatewayComponentOptions,
  vsComponentName as mainMachinesGatewayComponentName,
} from "./components/views/machines/component";
import { vsName as DepreciationModuleName } from "../../Depreciation";

export const vsName = "SlotTrak.Machines";
export const vsClientName = "gateway";

angular
  .module(vsName, [
    uiRouter,
    recordsModuleName,
    machinesComponentModuleName,
    machinesConfigModuleName,
    MachineSharedModuleName,
    DepreciationModuleName,
  ])
  .constant("clientName", vsClientName)
  .config(routeConfig)
  .config(machineDetailConfigurationsComponentConfig)
  .config(machineDetailPartsComponentConfig)
  .config(machineDetailProgressiveComponentConfig)
  .config(progressiveDefinitionSelectTypeConfig)
  .service(slotTrakServerAdapterName, SlotTrakServerAdapter)
  .service(CloneAndConversionServiceName, CloneAndConversionServiceGateway)
  .service(machineExportServiceName, MachineExportService)
  .component(
    MachinesDecommissionComponentName,
    MachinesDecommissionViewComponentOptions,
  )
  .component(
    MachinesWarehouseComponentName,
    MachinesWarehouseViewComponentOptions,
  )
  .component(MachinesMoveComponentName, MachinesMoveViewComponentOptions)
  .component(
    MachinesSoftwareUpgradeComponentName,
    MachinesSoftwareUpgradeViewComponentOptions,
  )
  .component(
    MachineDetailConfigurationsDecommissionComponentName,
    MachineDetailConfigurationsDecommissionComponentOptions,
  )
  .component(
    MachineDetailConfigurationsWarehouseComponentName,
    MachineDetailConfigurationsWarehouseComponentOptions,
  )
  .component(
    MachineDetailConfigurationsMoveComponentName,
    MachineDetailConfigurationsMoveComponentOptions,
  )
  .component(
    machineDetailPartsComponentName,
    machineDetailPartsComponentOptions,
  )
  .component(
    machineDetailProgressiveComponentName,
    MachineDetailProgressiveConfigurationComponentOptions,
  )
  .component(
    machineDetailProgressiveConfigurationEditComponentName,
    MachineDetailProgressiveConfigurationEditComponentOptions,
  )
  .component(
    MachineDetailProgressiveConfigurationGameInfoComponentName,
    MachineDetailProgressiveConfigurationGameInfoComponentOptions,
  )
  .component(
    mainMachinesGatewayComponentName,
    mainMachinesGatewayComponentOptions,
  );

export default vsName;
